import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import AnchorNav from '@/components/feature/AnchorNav';
import TenjinHero from './components/TenjinHero';
import TenjinServices from './components/TenjinServices';
import TenjinFlow from './components/TenjinFlow';
import TenjinArea from './components/TenjinArea';
import TenjinFaq from './components/TenjinFaq';
import TenjinContact from './components/TenjinContact';
import TenjinSeoJsonLd from './components/TenjinSeoJsonLd';

export default function TenjinYaPage() {
  useEffect(() => {
    document.title = '天神屋 | 福岡 出張買取専門店 - 貴金属・ブランド品・カメラ高価買取';
    const tenjinOgImage = 'https://public.readdy.ai/ai/img_res/3a89ad9b715a48f3f53c8a7bb7887ee9.jpg';
    const metas: { name?: string; property?: string; content: string }[] = [
      { name: 'description', content: '福岡市・福岡県全域への出張買取専門店「天神屋」。貴金属・宝石・ブランド品・カメラ・お酒・骨董品など幅広く高価買取。出張費・査定費完全無料。即日現金払い。古物商許可取得済み。' },
      { name: 'keywords', content: '福岡 出張買取,天神屋,福岡市 買取,貴金属買取 福岡,ブランド品買取 福岡,カメラ買取 福岡,出張買取 福岡県,骨董品買取 福岡,金買取 福岡,無料査定 福岡' },
      { property: 'og:title', content: '天神屋 | 福岡 出張買取専門店 - 貴金属・ブランド品・カメラ高価買取' },
      { property: 'og:description', content: '福岡市・福岡県全域への出張買取専門店。貴金属・ブランド品・カメラなど幅広く高価買取。出張費・査定費完全無料。' },
      { property: 'og:url', content: 'https://botan-buy.com/tenjin-ya' },
      { property: 'og:image', content: tenjinOgImage },
      { property: 'og:image:width', content: '1200' },
      { property: 'og:image:height', content: '630' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:image', content: tenjinOgImage },
      { name: 'twitter:title', content: '天神屋 | 福岡 出張買取専門店 - 貴金属・ブランド品・カメラ高価買取' },
      { name: 'twitter:description', content: '福岡市・福岡県全域への出張買取専門店。貴金属・ブランド品・カメラなど幅広く高価買取。出張費・査定費完全無料。' },
      { name: 'geo.region', content: 'JP-40' },
      { name: 'geo.placename', content: '福岡市中央区' },
      { name: 'geo.position', content: '33.5902;130.3738' },
    ];
    const existingMetas: HTMLMetaElement[] = [];
    metas.forEach(({ name, property, content }) => {
      const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
      let el = document.querySelector<HTMLMetaElement>(selector);
      if (!el) {
        el = document.createElement('meta');
        if (name) el.setAttribute('name', name);
        if (property) el.setAttribute('property', property);
        document.head.appendChild(el);
        existingMetas.push(el);
      }
      el.setAttribute('content', content);
    });

    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute('href') ?? '';
    if (canonical) canonical.setAttribute('href', 'https://botan-buy.com/tenjin-ya');

    return () => {
      document.title = '株式会社BotaN | 買取専門店天神屋・カードショップまんがく';
      if (canonical) canonical.setAttribute('href', prevCanonical);
    };
  }, []);

  return (
    <div className="font-sans">
      <TenjinSeoJsonLd />
      <Navbar />
      <div className="pt-20">
        <Breadcrumb items={[{ label: '買取専門店 天神屋' }]} />
      </div>
      <main>
        <TenjinHero />
        <AnchorNav
          accentColor="text-amber-700"
          items={[
            { icon: 'ri-price-tag-3-line', label: '取扱ジャンル', href: '#genres' },
            { icon: 'ri-route-line', label: '買取の流れ', href: '#flow' },
            { icon: 'ri-map-pin-2-line', label: '対応エリア', href: '#area' },
            { icon: 'ri-question-line', label: 'よくある質問', href: '#faq' },
            { icon: 'ri-phone-line', label: 'お問い合わせ', href: '#contact' },
          ]}
        />
        <TenjinServices />
        <TenjinFlow />
        <TenjinArea />
        <TenjinFaq />
        <TenjinContact />
      </main>
      <Footer />
    </div>
  );
}
